__turbopack_context__.v({
  "wrapper": "AdvertiserDisclosure-module-scss-module__PFuZcW__wrapper",
});
